import { CellEditor, CellEditorProps } from './types';
import { FC } from 'react';
import { Box } from '@ardoq/layout';
import { ErrorBoundary } from '@ardoq/error-boundary';

/**
 * Use this one for popup cell editors, as they are rendered in a portal and thus not inline during the wrapper's render.
 */
export const withPopupCellEditorErrorBoundary =
  <T,>(CellEditorComponent: CellEditor<T>): CellEditor<T> =>
  props => {
    // Cast to FC so we can use JSX syntax, which ensures the component renders
    // as a proper child node inside the boundary (not inline during the wrapper's
    // render). Errors thrown inline would propagate past the boundary.
    const Editor = CellEditorComponent as FC<CellEditorProps<T>>;
    return (
      <Box backgroundColor="surfaceDefault">
        <ErrorBoundary>
          <Editor {...props} />
        </ErrorBoundary>
      </Box>
    );
  };
